import React from 'react';
import { View } from 'react-native-web';
import {
  Activity_str, Published_str, SDK_str, Updated_str,
} from '../../../utils/DictionaryManagementUtils';
import RegularText from '../Text/RegularText';
import Title from '../Text/Title';
import Paragraph from '../Text/Paragraph';
import { convertDateFormat } from '../../../utils/Utils';

//= ========================================================================

const ActivityMenu = ({
  globJSON,
}) => {
  const activitiesList = [
    {
      action: Updated_str,
      date: globJSON.last_updated_at,
      creator: globJSON.updated_by,
    },
    {
      action: Published_str,
      date: globJSON.last_published_at,
      creator: globJSON.published_by,
    },
    {
      action: SDK_str,
      date: globJSON.last_sdk_created_at,
      creator: globJSON.sdk_created_by,
    },
  ];
  return (
    <View>
      <Title isBold>{Activity_str}</Title>
      {activitiesList.map((activityList) => (
        <View style={{ flexDirection: 'row' }}>
          <RegularText textMaxWidth={90} isBold>{activityList.action}</RegularText>
          {activityList.creator ? (
            <View style={{ flexDirection: 'row' }}>
              <RegularText textMaxWidth={160}>{activityList.creator}</RegularText>
              <Paragraph>{convertDateFormat(activityList.date)}</Paragraph>
            </View>
          )
            : <RegularText textMaxWidth={160}>{activityList.date}</RegularText>}
        </View>
      ))}
    </View>
  );
};

export default ActivityMenu;
